import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FilterMatchMode } from 'primereact/api';
import { Dialog } from 'primereact/dialog';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import AddEditResultTemplateDialog from './AddEditResultTemplate';
import moment from 'moment';
import Toast from '../../Shared/Toast/Toast';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { Sidebar } from 'primereact/sidebar';

const ResultTemplateConfiguration = () => {
    const { catchResponse } = useCatchResponse();
    const [resultTemplate, setResultTemplateList] = useState([]);
    const [masterData, setMasterData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [visibleSection, setVisibleSection] = useState(false);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ResultTemplate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [deleteId, setDeleteId] = useState('');

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetResultTemplateList(loginData?._id);
    }, []);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    const GetResultTemplateList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.GetResultTemplateConfigurationList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setResultTemplateList(res.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) { console.log(err);
            catchResponse(err);
         }
    }

    const actionBodyTemplate = (rows) => {
        return (
            <React.Fragment>
                <div className='p-d-flex p-ai-center'>
                    <Button icon="pi pi-pencil" className="e-sction-btn p-my-0 p-m-0" onClick={() => {
                        setMasterData(rows);
                        setVisible(true)
                    }} />
                    <Button icon="pi pi-trash" className="e-sction-btn p-my-0 p-mr-0 p-ml-2" onClick={(e) => {
                        setIsDeleteConfirmation(true);
                        setDeleteId(rows._id);
                    }} />
                </div>
            </React.Fragment>

        );
    };

    const lastUpdatedBodyTemplate = (rows) => {
        return (
            <div>{moment(rows?.UpdatedOn).format("DD-MM-YYYY HH:mm")}</div>
        );
    };

    const onCancel = () => {
        setVisible(false);
        setMasterData([]);
        setVisibleSection(false);
        GetResultTemplateList(securityUserID);
    }

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={(e) => DeleteTemplate()}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const DeleteTemplate = async () => {
        try {
            let data = {
                id: deleteId
            }
            await api.post(APIConstant.path.DeleteResultConfiguration, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Template deleted successfully' });
                    setDeleteId('');
                    GetResultTemplateList(securityUserID);
                }
                handleClose();
            }).catch(err => {
                Loader.hide();
                setDeleteId('');
                handleClose();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) { console.log(err);
            catchResponse(err);
         }
    }

    return (
        <div className='wayment-owner-dashboard'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-save"></i>
                    <h2>Result Template</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                    <Button icon="pi pi-plus" className="e-h-btn" onClick={() => setVisible(true)} />
                </div>
            </div>
            <DataTable
                value={resultTemplate}
                paginator
                rows={rows}
                first={first}
                filters={filters}
                filterDisplay="menu"
                responsiveLayout="scroll"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                rowsPerPageOptions={[5, 10, 20]}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                onPage={onPageChange}
                className='custom-table'
                scrollHeight='calc(100vh - 120px)'
                size='small'
            >
                <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." />
                <Column
                    field="TitleName"
                    header="Title"
                />
                <Column
                    body={lastUpdatedBodyTemplate}
                    header="Last Updated On"
                />
                <Column body={actionBodyTemplate} header="Action" headerStyle={{ display: 'flex', justifyContent: 'end' }}/>
            </DataTable>

            <Sidebar
                header={masterData?._id ? 'Edit Result Template' : 'Add Result Template'}
                 className='dialog-popup'
                visible={visible}
                onHide={() => onCancel()}
                draggable={false}
                position="right"
            >
                <AddEditResultTemplateDialog onCancel={onCancel} configId={masterData?._id} masterData={masterData} />

            </Sidebar>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
        </div>
    );
};

export default ResultTemplateConfiguration;
